import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { GlobalsService } from '../services/globals.service';
import { ReporteErrorService } from '../services/reporte-error.service';

import { ReporteError } from '../Models/ReporteError';


@Component({
  selector: 'app-reporte-error',
  templateUrl: './reporte-error.component.html',
  styleUrls: ['./reporte-error.component.css']
})
export class ReporteErrorComponent implements OnInit {

  public reporteError: ReporteError = new ReporteError();
  public reporteErrores: ReporteError[];


  constructor(private globalServices: GlobalsService, private ReporteErrorService: ReporteErrorService) { }

  ngOnInit() {
  }

  //Cuando lo busca
  CargarReporteError() {
    try {

      if (this.reporteError.referencia1 === undefined || this.reporteError.referencia1 === "") {
        this.reporteError.referencia1 = null;
      }
      if (this.reporteError.referencia2 === undefined || this.reporteError.referencia2 === "") {
        this.reporteError.referencia2 = null;
      }

      if (this.reporteError.referencia3 === undefined || this.reporteError.referencia3 === "") {
        this.reporteError.referencia3 = null;
      }

      this.ReporteErrorService.ObtenerReportePuntosVisita(this.globalServices.ObtenerCompania(), this.reporteError.fechaDocumento,
        this.reporteError.referencia1, this.reporteError.referencia2, this.reporteError.referencia3).subscribe(
          data => {
            this.reporteErrores = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });

    } catch (error) {
      console.log("cargar reporte error: " + error);
    }
  }

  //Cuando le da click para descargar el archivo
  RegistroSeleccionado(item) {

    this.downloadFile(item.documento);

  }


  downloadFile(data: Response) {

    var blob = new Blob([data], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    window.open(url);
  }
}
